module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/components/responsible/responsible-add/responsible-add.component.css
// module id = ./src/app/components/responsible/responsible-add/responsible-add.component.css
// module chunks = main